import { Box } from "@chakra-ui/react"
import { AUGMENTATION_PANEL_FIELD_TOUCH_TEXT_CSS } from "@pathwright/ux/src/components/augmentation/augmentationPanelStyles"
import Field from "@pathwright/ux/src/components/form/Field"
import { useFormikContext } from "formik"
import RichTextEditorWithMediaManager from "../../media-manager/RichTextEditorWithMediaManager"
import { useCoverPageContext } from "../CoverPageProvider"
import { COVER_PAGE_INLINE_EDITOR_SOFT_STYLES_SPACIOUS } from "../ui"

type CoverPagePanelRichTextFieldProps<TValues extends Record<string, any>> = {
  name: Extract<keyof TValues, string>
  label: string
  placeholder: string
  disabled: boolean
}

export function CoverPagePanelRichTextField<
  TValues extends Record<string, any>
>({
  name,
  label,
  placeholder,
  disabled
}: CoverPagePanelRichTextFieldProps<TValues>) {
  const form = useFormikContext<TValues>()
  const resourceId = useCoverPageContext((value) => value.resourceId)
  const mediaManagerContextKey = `resource-${resourceId}`
  const value = String(form.values[name] || "")

  return (
    <Field name={name} label={label}>
      {() => (
        <Box
          p={0}
          w="full"
          css={{
            "& .RichTextEditorControls": {
              right: 0
            },
            "& .ProseMirror": {
              backgroundColor: "transparent",
              border: "none",
              borderRadius: "augmentationPanelField",
              padding: "augmentationPanelGutter"
            }
          }}
        >
          <RichTextEditorWithMediaManager
            value={value}
            onChange={(nextValue) => {
              void form.setFieldValue(name, nextValue)
              void form.setFieldTouched(name, true, false)
            }}
            mediaManagerContextKey={mediaManagerContextKey}
            mode="edit"
            controlBar={{
              showEditButton: false,
              showSaveCancelButtons: false
            }}
            editorStyles={{
              ...COVER_PAGE_INLINE_EDITOR_SOFT_STYLES_SPACIOUS,
              bg: "augmentationPanel.fill.muted",
              borderColor: "transparent",
              borderRadius: "augmentationPanelField",
              "& .ProseMirror": {
                ...COVER_PAGE_INLINE_EDITOR_SOFT_STYLES_SPACIOUS[
                  "& .ProseMirror"
                ],
                backgroundColor: "transparent",
                borderRadius: "augmentationPanelField",
                padding: "augmentationPanelGutter",
                textStyle: "augmentationPanel",
                ...AUGMENTATION_PANEL_FIELD_TOUCH_TEXT_CSS
              }
            }}
            disabled={disabled}
            placeholder={placeholder}
          />
        </Box>
      )}
    </Field>
  )
}
